import { StripeProductId, type StripeProduct } from './Stripe.types';

export function getProduct(productId: StripeProductId) {
    return { id: StripeProductId[productId] } as StripeProduct;
}
